// extracted by mini-css-extract-plugin
export default {"button":"Cards_button__3meeX","buttonItem":"Cards_buttonItem__3pHJV","loading":"Cards_loading__nyfI+","spin":"Cards_spin__2WQge"};